// 검수 기록 쓰기 — 크리에이터·권리사 화면이 표를 직접 고치지 않고 함수로 부른다 (2026-09-27 · 기획 docs/ops/inspection-write-permission-plan.md ③)
//   서버: supabase/migrations/20260927160000_inspection_write_guard.sql
//   🔒 인자 이름은 마이그레이션 함수 인자와 같아야 한다 — inspectionWrites.test.js 가 SQL 을 읽어 대조한다.
//   🔒 운영팀 화면(AdminInspections · VideoInspectionReviewModal)은 운영팀 정책으로 직접 쓴다 — 여기 대상 아님.
import { supabase } from "./supabaseClient";

async function call(name, args) {
  const { data, error } = await supabase.rpc(name, args);
  if (error) throw error;
  return data;
}

/** 크리에이터 — 신청 취소(대기 · 수정 요청 · 재검수 대기) */
export const creatorCancel = (inspectionId) => call("inspection_creator_cancel", { p_inspection_id: inspectionId });

/** 크리에이터 — 「고쳤어요, 공개했어요」(고치면 바로 공개 가능 수정 요청 건). youtubeUrl 을 주면 주소도 바꾼다 → { status, fixed_reported_at, youtube_url } */
export const creatorFixed = (inspectionId, youtubeUrl = null) =>
  call("inspection_creator_fixed", { p_inspection_id: inspectionId, p_youtube_url: youtubeUrl });

/** 크리에이터 — 주소·원본 파일 저장, resubmit=true 면 「고쳤어요, 다시 검수 받기」(재검수 대기로) */
export const creatorEdit = (inspectionId, { youtubeUrl, originalFileUrl, resubmit = false }) =>
  call("inspection_creator_edit", {
    p_inspection_id: inspectionId,
    p_youtube_url: youtubeUrl ?? null,
    p_original_file_url: originalFileUrl ?? null,
    p_resubmit: Boolean(resubmit),
  });

/** 권리사 — 수정 요청의 「고친 뒤에는?」 · 고칠 것 항목 */
export const rightsSetRevisionMeta = (inspectionId, outcome, items = null) =>
  call("inspection_rights_set_revision_meta", { p_inspection_id: inspectionId, p_outcome: outcome, p_items: items });

/** 권리사 — 화이트리스트 요청 표시 */
export const rightsSetWhitelistRequested = (inspectionId, value) =>
  call("inspection_rights_set_whitelist_requested", { p_inspection_id: inspectionId, p_value: Boolean(value) });

/** 권리사 — 채널 단위 화이트리스트 처리 표시(그 채널·작품의 검수 건 전부, 내 회사 건만) → 바뀐 건수 */
export const rightsSetWhitelistProcessed = (ctvIds, value) =>
  call("inspection_rights_set_whitelist_processed", { p_ctv_ids: ctvIds, p_value: Boolean(value) });
